type FormatMoneyOptions = {
  locale?: string;
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
};

export function formatMoney(
  amount: number,
  currency: string,
  options: FormatMoneyOptions = {}
) {
  const value = Number(amount ?? 0);
  const code = String(currency || "USD").toUpperCase();
  const locale = options.locale ?? (code === "USD" ? "en-US" : "en-IN");

  try {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: code,
      minimumFractionDigits: options.minimumFractionDigits ?? 2,
      maximumFractionDigits: options.maximumFractionDigits ?? 2,
    }).format(value);
  } catch {
    // Fallback when Intl doesn't recognize currency code
    const rounded = Number.isFinite(value) ? value.toFixed(2) : "0.00";
    return `${code} ${rounded}`;
  }
}

